<template>
  <div class="position-relative h-100 w-100">
    <div class="map-header position-absolute text-light">
      <h2 class="h3 m-0"><span>Day 10 - </span>Raster</h2>
    </div>
    <div ref="map-root" class="basemap"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/src/css/mapbox-gl.css";
import * as SunCalc from "suncalc";

export default {
  data() {
    return {
      accessToken:
        "pk.eyJ1Ijoia21hcnNoYWxsIiwiYSI6ImNrdXdudGlpODI2ejkydXF2bXcyM3poaWQifQ.hyBCr6uwWlDGMGyVmuKCIw",
      map: null,
    };
  },
  methods: {
    getSunPosition(date) {
      const center = this.map.getCenter();
      const sunPos = SunCalc.getPosition(
        date || Date.now(),
        center.lat,
        center.lng
      );
      const sunAzimuth = 180 + (sunPos.azimuth * 180) / Math.PI;
      const sunAltitude = 90 - (sunPos.altitude * 180) / Math.PI;
      return [sunAzimuth, sunAltitude];
    },
    initMap() {
      mapboxgl.accessToken = this.accessToken;

      this.map = new mapboxgl.Map({
        container: this.$refs["map-root"],
        center: [-4.9996457, 56.776545],
        zoom: 12,
        pitch: 85,
        bearing: 80,
        style: "mapbox://styles/mapbox-map-design/ckhqrf2tz0dt119ny6azh975y",
      });

      this.map.on("load", () => {
        this.map.addSource("mapbox-dem", {
          type: "raster-dem",
          url: "mapbox://mapbox.mapbox-terrain-dem-v1",
          tileSize: 512,
          maxzoom: 14,
        });
        // add the DEM source as a terrain layer with exaggerated height
        this.map.setTerrain({ source: "mapbox-dem", exaggeration: 1.5 });

        // add a sky layer that will show when the map is highly pitched
        this.map.addLayer({
          id: "sky",
          type: "sky",
          paint: {
            "sky-type": "atmosphere",
            "sky-atmosphere-sun": this.getSunPosition(new Date()),
            "sky-atmosphere-sun-intensity": 5,
          },
        });
      });

      const nav = new mapboxgl.NavigationControl();
      this.map.addControl(nav, "top-right");
      this.map.scrollZoom.disable();
    },
  },
  mounted() {
    this.initMap();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/map-shared.scss";
</style>
